// extracted by mini-css-extract-plugin
export default {"row":"Counter_row__iKtNU","value":"Counter_value__DlDm9","button":"Counter_button__7PBsg","asyncButton":"Counter_asyncButton__9Pfcx","textbox":"Counter_textbox__GpSve"};